/**
 * TanStack Query client config.
 *
 * Mirrors the legacy `3mote-fe` defaults (staleTime 30s, retry once,
 * no refetch on window focus) so the new app feels the same to the
 * humans who lived through both stacks.
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
